import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as DiamondIcon } from './diamond.svg';

export const Diamond = IconHOC(DiamondIcon);
